import 'shared/common'
import { showGame } from '@carwow/carwow_theme/app/javascript/dead_end'

showGame()
